export default __webpack_public_path__ + "static/media/logo-white.c3a18421.png";